module.exports = __webpack_public_path__ + "static/media/ic_plazo_normativo_expand.32af4a21.svg";